import React from "react";
import { Router } from "@reach/router";
import config from "../config/config.js";

//
// CSS
//
import "./css/application.css";

//
// Services
//

//
// Components
//

//
// Pages
//
import HomePage from "../pages/home";

// Purchase Loan Tool Pages
import ApplicantInfoPage from "../pages/loan_tool/applicant_info";
import ClosingCostsWorksheetPage from "../pages/loan_tool/closing_costs_worksheet";
import DebtInfoPage from "../pages/loan_tool/debt_info/debt_info";
import DownPaymentCalculatorPage from "../pages/loan_tool/down_payment_calculator";
import IncomePage from "../pages/loan_tool/income";
import InvestReoPage from "../pages/loan_tool/invest_reo";
import LoanEstimatePriceEngineOptionsPage from "../pages/loan_tool/loan_estimate_price_engine_options";
import LoanEstimatePriceEnginePage from "../pages/loan_tool/loan_estimate_price_engine";
import LoanTypePage from "../pages/loan_tool/loan_type";
import FixAndFlipPage1Route from "../pages/loan_tool/fix_and_flip/page_1";
import FixAndFlipPage2Route from "../pages/loan_tool/fix_and_flip/page_2";
import FixAndFlipPage3Route from "../pages/loan_tool/fix_and_flip/page_3";
import FixAndFlipPage4Route from "../pages/loan_tool/fix_and_flip/page_4";
import FixAndFlipPrintAllRoute from "../pages/loan_tool/fix_and_flip/print_all";
import BorrowerAuthRoute from "../pages/loan_tool/forms/borrower_auth";
import BorrowerAuthCertRoute from "../pages/loan_tool/forms/borrower_auth_cert";
import CreditAuthRoute from "../pages/loan_tool/forms/credit_auth";
import PreQualLetterRoute from "../pages/loan_tool/forms/pre_qual_letter";
import PreApprovalLetterRoute from "../pages/loan_tool/forms/pre_approval_letter";
import RealtorAgentInformationRoute from "../pages/loan_tool/forms/realtor_agent_information";
import OpenHouseFlyerRoute from "../pages/loan_tool/forms/open_house_flyer";
import DscrCalculatorRoute from "../pages/loan_tool/forms/dscr_calculator";
import FullRealtorListRoute from "../pages/loan_tool/forms/full_realtor_list";
import NewPropertyPage from "../pages/loan_tool/new_property";
import ReservesPage from "../pages/loan_tool/reserves";
import SellingPropertyPage from "../pages/loan_tool/selling_property";
import SummarySheetPage from "../pages/loan_tool/summary_sheet";

import { UserProvider } from "../hooks/user";
import LoanTool from "./loan_tools/loan_tool";
import LoanToolRoot from "./loan_tools/loan_tool_root";
import PasswordReset from "../pages/password_reset";
import NotFound from "../pages/not_found";
import PasswordResetRequest from "../pages/password_reset_request";
import AccountProfile from "../pages/account_profile";
import CompanyAdminPanel from "../pages/company_admin_panel";
import { StripeProvider } from "react-stripe-elements";
import Subscribe from "../pages/subscribe";
import SystemAdminPanel from "../pages/system_admin_panel";
import SignUpReceipt from "../pages/sign_up_receipt";
import SignUpProfile from "../pages/sign_up_profile.js";
import SignUpPage from "../pages/sign_up";
import DashboardPage from "../pages/dashboard";

/**
 * Application is the highest-order component in the system.
 */
export default function Application() {
  return (
    <StripeProvider apiKey={config.stripePublicApiKey}>
      <Router>
        <UserProvider path="/">
          <HomePage path="/" />
          <SignUpPage path="/sign-up" />
          <SignUpReceipt path="/sign-up/receipt" />
          <SignUpProfile path="/sign-up/profile" />
          <AccountProfile path="/account-profile" />
          <CompanyAdminPanel path="/admin-panel" />
          <SystemAdminPanel path="system-admin-panel" />
          <Subscribe path="/subscribe" />
          <DashboardPage path="/dashboard" />

          <LoanTool path="/loan-tool/:documentId">
            <LoanToolRoot path="/" />
            <ApplicantInfoPage path="/applicant-info" />
            <ClosingCostsWorksheetPage path="/closing-costs" />
            <DebtInfoPage path="/debt-info" />
            <DownPaymentCalculatorPage path="/down-payment-calculator" />
            <IncomePage path="/income" />
            <InvestReoPage path="/invest-reo" />
            <LoanEstimatePriceEnginePage path="/loan-estimate-price-engine" />
            <LoanEstimatePriceEngineOptionsPage path="/loan-estimate-price-engine-options" />
            <LoanTypePage path="/loan-type" />
            <FixAndFlipPage1Route path="/fix-and-flip/page-1" />
            <FixAndFlipPage2Route path="/fix-and-flip/page-2" />
            <FixAndFlipPage3Route path="/fix-and-flip/page-3" />
            <FixAndFlipPage4Route path="/fix-and-flip/page-4" />
            <FixAndFlipPrintAllRoute path="/fix-and-flip/print-all" />
            <BorrowerAuthRoute path="/forms/borrower-auth" />
            <BorrowerAuthCertRoute path="/forms/borrower-auth-cert" />
            <CreditAuthRoute path="/forms/credit-auth" />
            <PreQualLetterRoute path="/forms/pre-qual-letter" />
            <PreApprovalLetterRoute path="/forms/pre-approval-letter" />
            <RealtorAgentInformationRoute path="/forms/realtor-agent-information" />
            <OpenHouseFlyerRoute path="/forms/open-house-flyer" />
            <DscrCalculatorRoute path="/forms/dscr-calculator" />
            <FullRealtorListRoute path="/forms/full-realtor-list" />
            <NewPropertyPage path="/new-property" />
            <ReservesPage path="/reserves" />
            <SellingPropertyPage path="/selling-property" />
            <SummarySheetPage path="/summary-sheet" />

            {/* Refinance */}
            <NewPropertyPage path="/subject-property" />
            <SellingPropertyPage path="/current-prop-info" />
            <DownPaymentCalculatorPage path="/loan-configurator" />

            <NotFound default />
          </LoanTool>

          <NotFound default />
        </UserProvider>

        <PasswordReset path="/password-reset/auth" />
        <PasswordResetRequest path="/password-reset-request" />
        <NotFound default />
      </Router>
    </StripeProvider>
  );
}
